import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { EntidadesProductiva } from '../entity-entidad-productiva/entity-entidades-productiva.model';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

// CHANGE
export const entityEntidadesProductivaTramiteChangeRequest = createAction(
  '[ENTITYENTIDADESPRODUCTIVATRAMITE] Change Request',
  props<{ item: EntidadesProductiva }>()
);

export const entityEntidadesProductivaTramiteChangeFailure = createAction(
  '[ENTITYENTIDADESPRODUCTIVATRAMITE] Change Failure',
  props<{ error: Error }>()
);

export const entityEntidadesProductivaTramiteChangeSuccess = createAction(
  '[ENTITYENTIDADESPRODUCTIVATRAMITE] Change Success',
  props<{ item: Update<EntidadesProductiva> }>()
);
